/**
 * Registration api script class
 *
 * @package    Api
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

export default class RegistrationApi {
    /**
     * Send request for load registration item
     */
    static loadItem (params) {
        return (axios) => axios.get('/ribyt/rsvp/registration/', {
            params,
        });
    }
}
